import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ProjectsApi, ApiClient } from '@skillz/crb.api.client'
import Moment from 'moment';
import CheckBox from '../../UI/CheckBox';
import Project from '../../lms-shared/UI/Project'
import classes from './ImportOldProjects.module.css'
import { onKeyDown } from "../../../service";
import SuccessProjectPopup from "../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";
import DynamicMessage from "../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../lms-shared/models/DynamicMessageTypeEnum";
import { ObjectTypeEnumText } from "../../../models/ObjectTypeEnum";
import { postJson } from "../../../utils";

const ImportOldProjects = ({ studyGroupId, closePopup }) => {
    const { direction, texts } = useSelector((state) => state.translate);
    const [message, setMessage] = useState(null)
    const [messagePopup, setMessagePopup] = useState()
    const [oldProjects, setOldProjects] = useState()
    const [load, setLoad] = useState(!oldProjects);
    const { uiData } = useSelector((state) => state.general);

    async function getData() {
        try {
            const response = await postJson('Project/filterRange', {}, window.config.ImportProjectsApiUrl);
            setLoad(false);
            const resdata = await response.json();
            resdata.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
            resdata.map(p => p.selected = false);
            setOldProjects(resdata);
        } catch (error) {
            setLoad(false);
            if (error === 404)
                setMessagePopup(
                    <DynamicMessage
                        type={DynamicMessageTypeEnum.Error}
                        content={texts.MessageContentOldProjects}
                        confirmFunc={() => setMessagePopup(null)} />
                );
            else
                setMessagePopup(
                    <DynamicMessage
                        type={DynamicMessageTypeEnum.Error}
                        title={texts.MessageTitleSubmissionsChangeStatus}
                        content={texts.MessageContentOldProjects}
                        confirmFunc={() => setMessagePopup(null)} />
                );
        }
    }


    useEffect(() => {
        if (studyGroupId) {
            getData()
        }
    }, [studyGroupId])

    function addProject(p) {
        setOldProjects((prev) => {
            const selectedCount = prev.filter(proj => proj.selected).length;

            if (selectedCount >= uiData.importProjectsRange) {
                return prev;
            }

            const addSelectProject = [...prev];
            const index = addSelectProject.indexOf(p);
            addSelectProject[index].selected = true;
            return addSelectProject;
        });
    }

    function removeProject(p) {
        setOldProjects((prev) => {
            var removeSelectProject = [...prev]
            var index = removeSelectProject.indexOf(p)
            removeSelectProject[index].selected = false
            return removeSelectProject
        })
    }

    async function importProjects(e) {
        try {
            const projectsIds = oldProjects.filter(p => p.selected).map(pr => pr.id);
            const data = {
                ids: projectsIds,
                refObjectType: ObjectTypeEnumText.StudyGroup,
                refObjectId: studyGroupId
            };
            const response = await postJson('project/importRange', data, window.config.ImportProjectsApiUrl);
            if (response.ok) {
                setMessage(
                    <SuccessProjectPopup
                        close={() => setMessage(null)}
                        color={"#0F2B4F"}
                        type="import"
                        title={texts.importProjectsFromLastYear}
                    >
                        <div className={classes.SuccessImportPopup}>{`${texts.SuccessImportPopup}!`}</div>
                    </SuccessProjectPopup>
                );
                closePopup(e);
            } else {
                throw new Error(`status from api ${response.status}`);
            }
        } catch (error) {
            setMessagePopup(
                <DynamicMessage
                    type={DynamicMessageTypeEnum.Error}
                    title={texts.MessageTitleSubmissionsChangeStatus}
                    content={texts.MessageContentCannotImportProjects}
                    confirmFunc={() => setMessagePopup(null)} />
            );
        }
    }

    return (
        <div className={classes.ImportOldProjectsWrapper}>
            {message}
            {messagePopup}
            <div className={classes.ImportOldProjects}>
                <div className={classes.Circle} onClick={(e) => closePopup(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => closePopup(e))}>
                    <div className={classes.XLine}></div>
                    <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                </div>
                <div className={classes.ImportHeader}>
                    <div className={classes.Title}>{texts.importProjectsFromLastYear}</div>
                    <p >{texts.importFromLastExplanation}</p>
                </div>
                {!load ? <>
                    {uiData && oldProjects && oldProjects.length > 0 ?
                        <>
                            <div className={`${classes[direction]} ${classes.Overflow}`}>
                                <div className={classes.OldProjects}>
                                    {oldProjects.map((p, i) =>
                                        <div className={classes.Project} key={i}>
                                            <CheckBox
                                                checked={p.selected}
                                                onChecked={() => addProject(p)}
                                                onRemoveChecked={() => removeProject(p)}
                                            // value={texts.selectAllClass}
                                            >
                                                <Project
                                                    project={p}
                                                    descriptionDate={Moment(p.createdDate).format('DD/MM/YY')}
                                                    noEditName={true}
                                                    oldProject={true} />
                                            </CheckBox>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={classes.ImportButton}>
                                <span className={oldProjects.filter(proj => proj.selected).length >= uiData.importProjectsRange ? classes.DisabledCheck : classes.Counter}>
                                    {uiData.importProjectsRange}/   <p className={classes.Selected}>{oldProjects.filter(proj => proj.selected).length}</p>
                                </span>
                                <div className={classes.ImportBtn} onClick={importProjects} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, importProjects)}>{texts.import}</div>
                            </div>
                        </>
                        :
                        <div className={classes.NoProjects}>{texts.noProjectsFromLastYear}</div>
                    }
                </>
                    : <div className={classes.Loader}></div>}
            </div>
        </div>
    )
}
export default ImportOldProjects